import React from 'react';
import { cn } from '../../utils/cn';

/**
 * Consistent horizontal rhythm and overflow guard for page content.
 * Layout already applies max-width + padding on `main`; this avoids double max-width while keeping `min-w-0` for flex/grid children.
 */
export function PageContainer({ as: Component = 'div', className, children, ...rest }) {
  return (
    <Component
      className={cn('w-full min-w-0 space-y-4 sm:space-y-6 md:space-y-8', className)}
      {...rest}
    >
      {children}
    </Component>
  );
}
